export class ExerciseType {
	static WeightAndReps = 1;
	static Reps = 2;
	static DistanceAndTime = 3;
	static Time = 4;
	static WeightAndTime = 5;
}